import React, { useState } from "react";
import { toast } from "sonner";
import { Newspaper, Loader2 } from "lucide-react";
import { api, formatApiError } from "../../lib/api";

export function NewspaperButtons() {
  const [busy, setBusy] = useState("");
  async function get(full) {
    setBusy(full ? "full" : "front");
    try {
      const r = await api.get(`/weddings/mine/newspaper.pdf?full=${full}`, { responseType: "blob" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(r.data);
      a.download = /filename="([^"]+)"/.exec(r.headers["content-disposition"] || "")?.[1] || (full ? "wedding-newspaper.pdf" : "wedding-front-page.pdf");
      a.click();
    } catch (e) {
      let msg = formatApiError(e);
      try { msg = JSON.parse(await e.response.data.text()).detail || msg; } catch { /* not json */ }
      toast.error(msg);
    } finally { setBusy(""); }
  }
  const btn = (full, label, id) => (
    <button onClick={() => get(full)} disabled={!!busy} className="btn-outline-gold !py-2 text-xs" data-testid={id}>
      {busy === (full ? "full" : "front") ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Newspaper className="w-3.5 h-3.5" />} {label}
    </button>
  );
  return (
    <div className="flex flex-wrap items-center gap-2 bg-white border border-[var(--line)] rounded-2xl p-4 mb-6" data-testid="newspaper-panel">
      <div className="mr-auto">
        <p className="font-serif text-xl">Your wedding newspaper</p>
        <p className="text-xs text-[var(--muted)]">The night's best headlines, ready to print. Your Top Story leads, then the most-loved cards.</p>
      </div>
      {btn(false, "Front page PDF", "newspaper-front-btn")}
      {btn(true, "Full newspaper PDF", "newspaper-full-btn")}
    </div>
  );
}
